<template>
  <div>
    <div class="back" v-on:click="goBack">
      Back to Dashboard
    </div>

    <div class="screen-count-container">
      <h3>Active Screens</h3>
      <span class="screen-count">{{activeScreens.length}}</span>
    </div>

    <div class="screen-count-container">
      <h3>Offline Screens</h3>
      <span class="screen-count offline">{{offlineScreens.length}}</span>
    </div>

    <div class="screen-count-container">
      <h3>Available Screens</h3>
      <span class="screen-count">{{availableScreens}}</span>
    </div>

    <h2>Active Screens: <span>{{activeScreens.length}}</span></h2>
    <hr>

    <div
      class="screen-container"
      v-for="screen in activeScreens"
      v-bind:key="screen._id"
      v-on:click="selectScreen(screen)">
        <div class="screen">
          <h3>{{screen.name}}</h3>
          <div>
            Status: <span class="online">Online</span>
          </div>
          <div>
            Displaying: {{ currentDeviceSlide(screen)}}
          </div>
        </div>
    </div>

    <h2>Offline Screens: <span class="offline">{{offlineScreens.length}}</span></h2>
    <hr>
    <div
      class="screen-container"
      v-for="screen in offlineScreens"
      v-bind:key="screen._id"
      v-on:click="selectScreen(screen)">
        <div class="screen">
          <h3>{{screen.name}}</h3>
          <div>
            Status: <span class="offline">Offline</span>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import '../styles/base.css'
import axios from 'axios'

export default {
  name: 'DeviceManagement',

  data () {
    return {
      activeScreens: [],
      availableScreens: 0,
      offlineScreens: []
    }
  },
  async mounted () {
    const pageSize = 5
    const pageNumber = 1
    const { data } = await axios.get(`/api/devices/?page=${pageNumber}&pageSize=${pageSize}`)
    // eslint-disable-next-line
    const { data: { hasNextPage, hasPrevPage, devices, page, total } } = data

    // eslint-disable-next-line
    let totalAvailableScreens = 0
    const { paid_screens: paidScreens = 0 } = await this.$store.dispatch('getCurrentUser')
    this.availableScreens = paidScreens - devices.length
    this.activeScreens = devices
  },
  methods: {
    goBack: function () {
      this.$parent.setSelectedPane('slide-builder')
    },
    selectScreen: function (screen) {
      console.log('Screen selected: ', screen)
    },
    currentDeviceSlide (device) {
      return `Unknown`
    }
  }
}
</script>

<style scoped>
  h3 {
    margin: 0;
  }

  hr {
    background: var(--border-grey);
    height: 1px;
    width: 100%;
  }

  img {
    display: block;
    margin: 0 auto;
    width: 70px;
  }

  .offline {
    color: var(--error) !important;
  }

  .online {
    color: var(--secondary);
  }

  .screen {
    text-align: center;
  }

  .screen-container {
    background: white;
    border: 1px solid var(--border-grey);
    border-radius: 6px;
    box-shadow: 0 1px 9px 1px rgba(39,39,39,.2);
    display: inline-block;
    height: 140px;
    justify-content: space-around;
    margin: 1em;
    padding: 2em 1em;
    transition: all 0.25s ease-out;
    width: 288px;
  }

  .screen-container:hover {
    transform: scale(1.1);
  }

  .screen-count {
    color: var(--secondary);
    font-size: 3.5em;
  }

  .screen-count-container {
    background: white;
    border: 1px solid var(--border-grey);
    border-radius: 6px;
    display: inline-block;
    height: 140px;
    justify-content: space-around;
    margin: 1em;
    padding: 1em;
    width: 288px;
  }

  span {
    color: var(--secondary);
  }

  @media only screen and (max-width: 676px) {
    .button {
      width: 284px;
    }

    .new-screen-container {
      width: 288px;
    }
  }
</style>
